import React from "react";

import { useTranslation, Trans } from "react-i18next";

import Button from '../Button'

import stars from '../../img/SupportAndFaq/stars.png';
import people from '../../img/SupportAndFaq/people.png'

function WeValue () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative pt-[40px] xl:pt-[70px]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
                <div className="flex flex-col xl:flex-row justify-between gap-[20px]">
                    <div>
                        <p className="text-[#353535] italic font-[700] text-[32px] xl:text-[40px] merriweather">{t('supandfaq.31')}</p>
                        <Button className="mt-[40px] hidden md:block"/>
                    </div>
                    <div>
                        <p className="text-[#232A36] text-[14px] xl:text-[16px] font-[300] md:max-w-[483px] inter">{t('supandfaq.32')}</p>
                        <p className="text-[#232A36] text-[14px] xl:text-[16px] font-[300] md:max-w-[483px] mt-[15px] inter">{t('supandfaq.33')}</p>
                        <Button className="mt-[40px] md:hidden block"/>
                    </div>
                </div>
                <div className="flex flex-wrap mt-[50px] gap-[20px] xl:h-[200px]">
                    <div className="w-[600px] flex-grow py-[30px] px-[20px] xl:px-[40px] bg-white rounded-[20px] border border-[#1D3C3F]">
                        <div className="flex flex-col xl:flex-row justify-between xl:items-center gap-[30px]">
                            <div>
                                <p className="italic opne-sans text-[32px] xl:text-[40px]">4,5</p>
                                <img src={stars} alt="" />
                                <p className="font-[300] open-sans leading-[1.2] text-[25px]">{t('supandfaq.34')}</p>
                            </div>
                            <img src={people} alt="" />
                        </div>
                    </div>
                    <div className="bg-[#DCDCDC] h-[90px] md:h-auto rounded-[20px] flex-grow xl:w-[290px] flex items-center justify-center">
                        <p className="text-center open-sans fdfd leading-[1.2] text-[16px] xl:text-[25px]"><Trans>{t('supandfaq.35')}</Trans></p>
                    </div>
                    <div className="bg-[#DCDCDC] h-[90px] md:h-auto rounded-[20px] flex-grow xl:w-[290px] flex items-center justify-center">
                        <p className="text-center open-sans fdfd leading-[1.2] text-[16px] xl:text-[25px]"><Trans>{t('supandfaq.36')}</Trans></p>
                    </div>
                </div>
                <div className="flex flex-wrap mt-[20px] gap-[20px] xl:h-[200px]">
                    <div className="bg-[#DCDCDC] h-[90px] md:h-auto rounded-[20px] flex-grow xl:w-[290px] flex items-center justify-center">
                        <p className="text-center open-sans fdfd leading-[1.2] text-[16px] xl:text-[25px]"><Trans>{t('supandfaq.37')}</Trans></p>
                    </div>
                    <div className="bg-[#DCDCDC] h-[90px] md:h-auto rounded-[20px] flex-grow xl:w-[290px] flex items-center justify-center">
                        <p className="text-center open-sans fdfd leading-[1.2] text-[16px] xl:text-[25px]"><Trans>{t('supandfaq.38')}</Trans></p>
                    </div>
                    <div className="w-[600px] py-[20px] xl:py-[55px] px-[20px] xl:px-[40px] rounded-[20px] bgwe">
                        <div className="flex flex-col items-center xl:items-start">
                            <p className="open-sans leading-[1.2] text-[25px] xl:text-[32px] text-white">{t('supandfaq.39')}</p>
                            <p className="open-sans leading-[1.2] text-[25px] xl:text-[32px] text-white">{t('supandfaq.40')}</p>
                        </div>
                    </div>
                </div>                
            </div>
        </div>
    );
}

export default WeValue;